import styled, { css } from 'vue-styled-components';

import theme from '@/config/theme';

const modifiers = {
  type: {
    custumize: () => css`
      border-color: #7a297a;
      color: #fff;
      box-shadow: 0 0 40px 40px  #7a297a inset, 0 0 0 0  #7a297a;
      -webkit-transition: all 150ms ease-in-out;
      transition: all 150ms ease-in-out;
    `,
    custumizeModal: () => css`
      background-color: ${theme.colors.primaryBlue};
      color: ${theme.colors.white};

      &:not([disabled]):hover {
        opacity: 0.8;
      }
      position: relative; 
      top: 28px;
    `,
    primary: () => css`
      background-color: ${theme.colors.primaryBlue};
      color: ${theme.colors.white};

      &:not([disabled]):hover {
        opacity: 0.8;
      }
    `,
    secondary: () => css`
      background-color: ${theme.colors.white};
      border: 1px solid ${theme.colors.primaryBlue};
      color: ${theme.colors.primaryBlue};

      &:not([disabled]):hover {
        background-color: ${theme.colors.primaryBlue};
        color: ${theme.colors.white};
      }
    `,
    success: () => css`
      background-color: ${theme.colors.supportSuccessDark};
      color: ${theme.colors.white};

      &:not([disabled]):hover {
        background-color: ${theme.colors.supportSuccess};
      }
    `,
    danger: () => css`
      background-color: ${theme.colors.supportError};
      color: ${theme.colors.white};

      &:not([disabled]):hover {
        background-color: ${theme.colors.supportError};
      }
    `,
    error: () => css`
      background-color: ${theme.colors.supportErrorDark};
      color: ${theme.colors.white};

      &:not([disabled]):hover {
        background-color: ${theme.colors.supportError};
      }
    `,
  },
  size: {
    sm: () => css`
      padding: ${theme.spacings.xsmall} ${theme.spacings.medium};
    `,
    md: () => css`
      padding: ${theme.spacings.small} ${theme.spacings.xlarge};
    `,
    lg: () => css`
      padding: ${theme.spacings.medium} ${theme.spacings.xxxlarge};
    `,
  },
};

const buttonProps = {
  type: String,
  size: String,
  shadow: Boolean,
};

export const ButtonSizes = ['sm', 'md', 'lg'] as const;
export const ButtonTypes = ['primary', 'secondary', 'success', 'error', 'danger'] as const;

export type ButtonProps = {
  type: typeof ButtonTypes[number];
  size: typeof ButtonSizes[number];
  shadow: boolean;
};

export const Wrapper = styled('button', buttonProps)`
  ${({ type, size, shadow }: ButtonProps) => css`
    border-radius: ${theme.border.radius.small};
    font-size: 14px;
    line-height: 24px;
    transition: .5s all;
    ${shadow && `box-shadow: ${theme.shadow.btDefault}`};
    ${modifiers.type[type]}
    ${modifiers.size[size]}

    &:not([disabled]) {
      cursor: pointer;
    }

    &[disabled] {
      opacity: 0.7;
    }
    #solicity{
      margin-top: 20px;
    }
    & span.text {
      display: none;
    }

    & span.spinner {
      margin: 0 auto;
      display: block;
      border-radius: 100%;
      width: 1.25rem;
      height: 1.25rem;
      border: 3px solid #dcdcdc;
      border-left-color: ${theme.colors.gray5};
      animation: loading 1s linear infinite;

      @keyframes loading {
        100% {
          transform: rotate(360deg);
        }
      }
    }
  `}
`;
